import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';

import WixSDK from 'shared/utils/wix-sdk';
import VIEW_MODES from 'shared/constants/view-modes';

import { getRequestedWidgetSize } from 'shared/selectors/app-settings';


// TODO use at mobile, classic & strip too
@connect(state => ({
  requestedWidgetSize: getRequestedWidgetSize(state),
}))
export default class ResizeWidgetByContent extends React.Component {

  static propTypes = {
    requestedWidgetSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),
    children: React.PropTypes.element,
  };

  componentDidMount() {
    this.interval = setInterval(this.updateSize, 300);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  interval = null;
  containerEl = null;

  get containerSize() {
    return {
      width: Math.ceil(_.get(this.containerEl, 'clientWidth', 0)),
      height: Math.ceil(_.get(this.containerEl, 'clientHeight', 0)),
    };
  }

  @autobind
  updateSize() {
    const newSize = this.containerSize;
    if (!newSize.width || !newSize.height || _.isEqual(this.props.requestedWidgetSize, newSize)) {
      return;
    }

    this.currentContentSize = newSize;
    if (WixSDK.Utils.getViewMode() === VIEW_MODES.EDITOR) {
      // editor
      WixSDK.resizeComponent(newSize);
    } else {
      // viewer
      WixSDK.resizeWindow(newSize.width, newSize.height);
    }
    // fix TPA bug. TODO remove
    WixSDK.setHeight(newSize.height, { overflow: false });
  }

  render() {
    return (
      <div ref={node => (this.containerEl = node)}
           style={{ display: 'inline-block' }}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/resize-widget-by-content/resize-widget-by-content.js